import classNames from 'lib/classNames';
import React from 'react';
import styles from 'styles/custom_scroll.module.scss'

export default function CustomScroll (props) {
    const { children, isMobile, style, trackBg = "#ffffff", thumbBg = "#afafaf", className, scrollRef } = props
    const finalClassName = [className, styles.custom_scrollbar, isMobile && 'isMobile'].filter(Boolean).join(' ')
    return <div className={finalClassName} ref={scrollRef} style={Object.assign({}, style, {
        "--trackBg": trackBg,
        "--thumbBg": thumbBg,
    })}  >
        {children}
    </div>
}